import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { formatMessage } from '../../lib/intl';

const i18n = defineMessages({
  title: {
    id: 'expiredCopy.withPayments.title',
    defaultMessage: 'Deadline',
  },
  text: {
    id: 'expiredCopy.withPayments.text',
    defaultMessage: `You did not make the most recent payment on time.
      Your purchase and payment(s) to date are at risk per the
      {merchantName} policies unless they grant you an extension
      to make the most recent payment.`,
  },
});
const ExpiredCopyWithPayments = ({ merchantName, intl }) => (
  <div>
    <strong className="d-block mb-2">{formatMessage(intl)(i18n.title)}</strong>
    {formatMessage(intl)(i18n.text, { merchantName })}
  </div>
);

export default injectIntl(ExpiredCopyWithPayments);



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/expired-copy.with-payments.js